import React, { useState } from "react";
import { Box, Typography, TextField, Button, Grid } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { createStrategicGoal } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function StrategicGoalCreatePage() {
  const { businessDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const [form, setForm] = useState({ successFactorName: "", successFactorDescription: "" });
  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createStrategicGoal({ ...form, businessDomainId });
      notify.success(t("message.create.success"));
      navigate(`/strategy/${businessDomainId}/strategic-goals`);
    } catch (err) { notify.apiError(err); }
  };
  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("strategicGoal.create.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}><TextField fullWidth required label={t("successFactor.name")} name="successFactorName" value={form.successFactorName} onChange={handleChange} /></Grid>
          <Grid item xs={12}><TextField fullWidth multiline rows={3} label={t("common.description")} name="successFactorDescription" value={form.successFactorDescription} onChange={handleChange} /></Grid>
        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.save")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/strategy/${businessDomainId}/strategic-goals`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
